import * as types from "./strategicdemandactionType";

/* =========================
   Volume Trend Report Dropdown
   ========================= */
export const fetchStrategicVolumeTrendReportsDDRequest = () => ({
  type: types.FETCH_VOLUME_TREND_REPORTS_DD_REQUEST,
});

export const fetchStrategicVolumeTrendReportsDDSuccess = (payload) => ({
  type: types.FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS,
  payload,
});

export const fetchStrategicVolumeTrendReportsDDFailure = (error) => ({
  type: types.FETCH_VOLUME_TREND_REPORTS_DD_FAILURE,
  error,
});

/* =========================
   Strategic Reports (Reports Tab)
   ========================= */
export const fetchStrategicReportsTabRequest = (payload) => ({
  type: types.FETCH_STRATEGIC_REPORTS_TAB_REQUEST,
  payload,
});

export const fetchStrategicReportsTabSuccess = (payload) => ({
  type: types.FETCH_STRATEGIC_REPORTS_TAB_SUCCESS,
  payload,
});

export const fetchStrategicReportsTabFailure = (error) => ({
  type: types.FETCH_STRATEGIC_REPORTS_TAB_FAILURE,
  error,
});

/* =========================
   Export Strategic Reports
   ========================= */
export const exportStrategicReportsRequest = (payload) => ({
  type: types.EXPORT_STRATEGIC_REPORTS_REQUEST,
  payload,
});

export const exportStrategicReportsSuccess = (payload) => ({
  type: types.EXPORT_STRATEGIC_REPORTS_SUCCESS,
  payload,
});

export const exportStrategicReportsFailure = (error) => ({
  type: types.EXPORT_STRATEGIC_REPORTS_FAILURE,
  error,
});

/* =========================
   Delete Strategic Demand Report
   ========================= */
export const deleteStrategicDemandReportRequest = (payload) => ({
  type: types.DELETE_STRATEGIC_DEMAND_REPORT_REQUEST,
  payload,
});

export const deleteStrategicDemandReportSuccess = (payload) => ({
  type: types.DELETE_STRATEGIC_DEMAND_REPORT_SUCCESS,
  payload,
});

export const deleteStrategicDemandReportFailure = (error) => ({
  type: types.DELETE_STRATEGIC_DEMAND_REPORT_FAILURE,
  error,
});

/* =========================
   Update Report Notes
   ========================= */
export const updateBlockPlanningReportNoteRequest = (payload) => ({
  type: types.UPDATE_BLOCK_PLANNING_REPORT_NOTE_REQUEST,
  payload,
});

export const updateBlockPlanningReportNoteSuccess = () => ({
  type: types.UPDATE_BLOCK_PLANNING_REPORT_NOTE_SUCCESS,
});

export const updateBlockPlanningReportNoteFailure = (error) => ({
  type: types.UPDATE_BLOCK_PLANNING_REPORT_NOTE_FAILURE,
  error,
});

/* =========================
   Block Capacity Table
   ========================= */
export const fetchBlockCapacityTableReportRequest = (payload) => ({
  type: types.FETCH_BLOCK_CAPACITY_TABLE_REPORT_REQUEST,
  payload,
});

export const fetchBlockCapacityTableReportSuccess = (payload) => ({
  type: types.FETCH_BLOCK_CAPACITY_TABLE_REPORT_SUCCESS,
  payload,
});

export const fetchBlockCapacityTableReportFailure = (error) => ({
  type: types.FETCH_BLOCK_CAPACITY_TABLE_REPORT_FAILURE,
  error,
});

/* =========================
   Block Planning Demand Input
   ========================= */
export const fetchBlockPlanningDemandInputRequest = (payload) => ({
  type: types.FETCH_BLOCK_PLANNING_DEMAND_INPUT_REQUEST,
  payload,
});

export const fetchBlockPlanningDemandInputSuccess = (payload) => ({
  type: types.FETCH_BLOCK_PLANNING_DEMAND_INPUT_SUCCESS,
  payload,
});

export const fetchBlockPlanningDemandInputFailure = (error) => ({
  type: types.FETCH_BLOCK_PLANNING_DEMAND_INPUT_FAILURE,
  error,
});

/* =========================
   Site Onboarding Legend
   ========================= */
export const fetchOnboardingSiteLegendRequest = () => ({
  type: types.FETCH_ONBOARDING_SITE_LEGEND_REQUEST,
});

export const fetchOnboardingSiteLegendSuccess = (payload) => ({
  type: types.FETCH_ONBOARDING_SITE_LEGEND_SUCCESS,
  payload,
});

export const fetchOnboardingSiteLegendFailure = (error) => ({
  type: types.FETCH_ONBOARDING_SITE_LEGEND_FAILURE,
  error,
});

/* =========================
   Draft Demand Planning
   ========================= */
export const draftBlockDemandPlanningRequest = (payload) => ({
  type: types.DRAFT_BLOCK_DEMAND_PLANNING_REQUEST,
  payload,
});

export const draftBlockDemandPlanningSuccess = (payload) => ({
  type: types.DRAFT_BLOCK_DEMAND_PLANNING_SUCCESS,
  payload,
});

export const draftBlockDemandPlanningFailure = (error) => ({
  type: types.DRAFT_BLOCK_DEMAND_PLANNING_FAILURE,
  error,
});

/* =========================
   Publish Demand Planning
   ========================= */
export const publishBlockDemandPlanningRequest = (payload) => ({
  type: types.PUBLISH_BLOCK_DEMAND_PLANNING_REQUEST,
  payload,
});

export const publishBlockDemandPlanningSuccess = (payload) => ({
  type: types.PUBLISH_BLOCK_DEMAND_PLANNING_SUCCESS,
  payload,
});

export const publishBlockDemandPlanningFailure = (error) => ({
  type: types.PUBLISH_BLOCK_DEMAND_PLANNING_FAILURE,
  error,
});

/* =========================
   Demand Input Filter Dropdowns
   ========================= */
export const fetchDemandInputFilterDDRequest = (reportId) => ({
  type: types.FETCH_DEMAND_INPUT_FILTER_DD_REQUEST,
  payload: { reportId },
});

export const fetchDemandInputFilterDDSuccess = (payload) => ({
  type: types.FETCH_DEMAND_INPUT_FILTER_DD_SUCCESS,
  payload,
});

export const fetchDemandInputFilterDDFailure = (error) => ({
  type: types.FETCH_DEMAND_INPUT_FILTER_DD_FAILURE,
  error,
});
// strategicdemandaction.js
export const fetchWorklistByRPCERequest = (rpceID) => ({
  type: types.FETCH_WORKLIST_BY_RPCE_DEMAND_REQUEST,
    payload: rpceID,
});

export const fetchWorklistByRPCESuccess = (data) => ({
  type: types.FETCH_WORKLIST_BY_RPCE_DEMAND_SUCCESS,
    payload: data
});

export const fetchWorklistByRPCEFailure = (error) => ({
  type: types.FETCH_WORKLIST_BY_RPCE_DEMAND_FAILURE,
  error,
});
export const fetchPracticeByWorklistRequest = (worklistID) => ({
    type: types.FETCH_PRACTICE_BY_WORKLIST_REQUEST,
    payload: worklistID
});

export const fetchPracticeByWorklistSuccess = (data) => ({
    type: types.FETCH_PRACTICE_BY_WORKLIST_SUCCESS,
    payload: data
});

export const fetchPracticeByWorklistFailure = (error) => ({
    type: types.FETCH_PRACTICE_BY_WORKLIST_FAILURE,
    payload: error
});
// strategicdemandaction.js
export const fetchSiteOnboardingPlannerRequest = (payload) => ({
  type: types.FETCH_SITE_ONBOARDING_PLANNER_REQUEST,
  payload,
});

export const fetchSiteOnboardingPlannerSuccess = (payload) => ({
  type: types.FETCH_SITE_ONBOARDING_PLANNER_SUCCESS,
  payload,
});

export const fetchSiteOnboardingPlannerFailure = (error) => ({
  type: types.FETCH_SITE_ONBOARDING_PLANNER_FAILURE,
  error,
});
export const fetchSiteOffboardingPlannerRequest = (payload) => ({
  type: types.FETCH_SITE_OFFBOARDING_PLANNER_REQUEST,
  payload,
});

export const fetchSiteOffboardingPlannerSuccess = (payload) => ({
  type: types.FETCH_SITE_OFFBOARDING_PLANNER_SUCCESS,
  payload,
});

export const fetchSiteOffboardingPlannerFailure = (error) => ({
  type: types.FETCH_SITE_OFFBOARDING_PLANNER_FAILURE,
  error,
});
export const fetchBlockPlanningDemandDailyRequest = (payload) => ({
  type: types.FETCH_BLOCK_PLANNING_DEMAND_DAILY_REQUEST,
  payload,
});

export const fetchBlockPlanningDemandDailySuccess = (payload) => ({
  type: types.FETCH_BLOCK_PLANNING_DEMAND_DAILY_SUCCESS,
  payload,
});

export const fetchBlockPlanningDemandDailyFailure = (error) => ({
  type: types.FETCH_BLOCK_PLANNING_DEMAND_DAILY_FAILURE,
  error,
});
// strategicdemandaction.js
export const fetchDemandQuarterlyRequest = (payload) => ({
  type: types.FETCH_DEMAND_QUARTERLY_REQUEST,
  payload,
});

export const fetchDemandQuarterlySuccess = (data) => ({
  type: types.FETCH_DEMAND_QUARTERLY_SUCCESS,
  payload: data,
});

export const fetchDemandQuarterlyFailure = (error) => ({
  type: types.FETCH_DEMAND_QUARTERLY_FAILURE,
  error,
});

//Fetch Week and Quarter
export const fetchWeekAndQuarterRequest = (payload) => ({
  type: types.FETCH_WEEK_OR_QUARTER_REQUEST,
  payload,
});

export const fetchWeekAndQuarterSuccess = (payload) => ({
  type: types.FETCH_WEEK_OR_QUARTER_SUCCESS,
  payload,
});

export const fetchWeekAndQuarterFailure = (error) => ({
  type: types.FETCH_WEEK_OR_QUARTER_FAILURE,
  error,
});

